import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router';
import {CircularProgress, Divider, Paper, Stack, Typography} from '@mui/material';
import ReadbookHeader from './ReadbookHeader';
import EditableSection from './EditableSection';
import ReadbookTask from "./ReadbookTask";
import ReadbookItems from "./ReadbookItems";
import ProductPreviewSection from "../../components/ProductPreview/ProductPreviewSection";

const _awpBase = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';
function _authH() { const t = localStorage.getItem('access_token'); return t ? {Authorization: `Bearer ${t}`} : {}; }

const ReadbookPage = () => {
    const {readbookId} = useParams();
    const [readbook, setReadbook] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!readbookId) return;
        fetch(`${_awpBase}/api/readbooks/${encodeURIComponent(readbookId)}`, {headers: _authH()})
            .then(r => { if (r.status === 404) { setError(new Error('Not found')); setLoading(false); return null; } return r.ok ? r.json() : null; })
            .then(data => { if (data) { setReadbook({id: readbookId, ...data}); } setLoading(false); })
            .catch(err => { console.error('Readbook fetch error', err); setError(err); setLoading(false); });
    }, [readbookId]);

    if (loading) return <Stack alignItems="center" p={2}><CircularProgress/></Stack>;
    if (error) return <Paper sx={{p: 2}}><Typography color="error">{error.message}</Typography></Paper>;
    if (!readbook) return <Paper sx={{p: 2}}><Typography>No readbook found</Typography></Paper>;

    return (
        <Stack height={'100vh'}>
            <ReadbookHeader
                readbookId={readbookId}
                title={readbook.title}
                onTitleUpdated={(next) => setReadbook(rb => ({...rb, title: next}))}/>
            <Divider/>

            <Stack overflow={'hidden'} flex={1}>
                <Stack
                    direction={'row'}
                    overflow={'hidden'}
                    flex={1}
                >
                    <Stack
                        width={'20%'}
                        bgcolor={'white'}
                        overflow={'auto'}
                    >

                        <Stack p={2} spacing={1}>

                            <Typography variant="body1" fontWeight={600}>Feed settings</Typography>

                            <EditableSection
                                title="Sources"
                                items={readbook.sources}
                                fieldKey="sources"
                                readbookId={readbookId}
                                onSaved={(next) => setReadbook(rb => ({...rb, sources: next}))}
                            />

                            <EditableSection
                                title="Entities"
                                items={readbook.entities}
                                fieldKey="entities"
                                readbookId={readbookId}
                                onSaved={(next) => setReadbook(rb => ({...rb, entities: next}))}
                            />

                            <EditableSection
                                title="Indicators"
                                items={readbook.indicators}
                                fieldKey="indicators"
                                readbookId={readbookId}
                                onSaved={(next) => setReadbook(rb => ({...rb, indicators: next}))}
                            />

                            <EditableSection
                                title="Triggers"
                                items={readbook.triggers}
                                fieldKey="triggers"
                                readbookId={readbookId}
                                onSaved={(next) => setReadbook(rb => ({...rb, triggers: next}))}
                            />


                            <ReadbookTask/>
                        </Stack>

                    </Stack>


                    <Divider orientation={'vertical'}/>

                    <Stack
                        width={'30%'}
                        bgcolor={'white'}

                        overflow={'auto'}
                    >
                        <ReadbookItems/>
                    </Stack>


                    <Divider orientation={'vertical'}/>


                    <Stack
                        width={'50%'}
                        bgcolor={'white'}
                        overflow={'auto'}
                    >
                        <ProductPreviewSection/>
                    </Stack>
                </Stack>

            </Stack>
        </Stack>
    );
};

export default ReadbookPage;
